import * as angular from "angular";
import {IController} from "angular";
import {TextTemplatePurposeType} from "../../../text-templates/types/text-template-purpose.type";

export class notificationsTableRowCtrl implements IController {

  notification: any;
  defaultLanguage: any;
  purpose: TextTemplatePurposeType;
  onEdit: Function;

  private messagesRef: any;
  private message: any;
  public textTemplatePurposeType: typeof TextTemplatePurposeType = TextTemplatePurposeType;
  public versions: number;

  constructor() {
  }

  $onInit() {
    this.messagesRef = this.notification.messages[this.defaultLanguage];
    this.message = this.messagesRef.current ? this.messagesRef.current : this.messagesRef.original;

    this.initVersionsCount();
  }

  private initVersionsCount() {
    this.versions = 1;

    if (!!this.notification.specialTagMap) {
      this.versions += Object.keys(this.notification.specialTagMap).length || 0;
    }

    if (!!this.notification.specialProgramMap) {
      this.versions += Object.keys(this.notification.specialProgramMap).length || 0;
    }
  }

}

angular
  .module('bringoz.admin.notifications')
  .component('notificationsTableRow', {
    bindings: {
      notification: '<',
      defaultLanguage: '<',
      purpose: '<?',
      onEdit: '&'
    },
    template: require('./notifications-table-row.html').default,
    controller: notificationsTableRowCtrl
  });
